//types
import {IOrganizationTicketsTiers, TableAndTickets} from '@/utils/types';

export const getNewTableValues = (tableInfoId: number, amount: number) => {
	return {
		tableInfoId,
		name: '',
		purchaserIsNotAttending: false,
		attendees: Array.from({length: amount}, () => ({
			firstName: '',
			lastName: '',
			email: '',
			phoneNumber: '',
			meals: [],
		})),
	};
};

export const getUpdatedTableValues = (setTables: TableAndTickets[], tableInfoId: number) => {
	const indexToRemove = setTables.findIndex((table) => table.tableInfoId === tableInfoId);
	if (indexToRemove !== -1) setTables.splice(indexToRemove, 1);
	return setTables;
};

export const getCurrentAmount = (setTables: TableAndTickets[], tableId: number) =>
	setTables.filter((table) => table.tableInfoId === tableId).length;

export const getTablesSubtotal = (
	setTables: TableAndTickets[],
	ticketsTiers: IOrganizationTicketsTiers[],
	tableId: number
) => {
	const filteredTables = setTables.filter((table) => table.tableInfoId === tableId);
	const numberOfTables = filteredTables.length;

	const tier = ticketsTiers.find((t) => t.id === tableId);
	return tier ? numberOfTables * tier.price : 0;
};

export const getTablesCalculatedTotal = (
	setTables: TableAndTickets[],
	ticketsTiers: IOrganizationTicketsTiers[],
	isCoverFee?: boolean
) => {
	return setTables.reduce(
		(total, table) => {
			const tier = ticketsTiers.find((t) => t.id === table.tableInfoId);
			return total + (tier ? tier.price : 0);
		},
		isCoverFee ? 3 : 0
	);
};
